// extracted by mini-css-extract-plugin
module.exports = {"roundImageBox":"RoundImage_roundImageBox__YrUGl","roundImage":"RoundImage_roundImage__1c5gk"};